import { useTooltip } from './useTooltip'

export function useTableTooltip(options?: { width?: number; height?: number; hideDelay?: number }) {
  return useTooltip(options)
}
